<template>
  <div>
    <section class="g-filterSearch uc-ml10">
      <div
        v-for="(item, index) in tabList"
        :key="index"
        class="item"
        :class="item.status == query.status ? 'on' : ''"
        @click="
          query.status = item.status;
          query.pageIndex = 1;
          loadData();
        "
      >
        {{ item.name }}
      </div>
      <div class="search">
        <input
          type="text"
          placeholder="请输入您想搜索的课程"
          class="uc-input"
          v-model="query.keyword"
          @keyup.enter="loadData"
        />
        <input
          type="submit"
          value="搜索"
          class="uc-btn blue"
          @click="loadData"
        />
      </div>
    </section>

    <section class="g-listLine uc-ml10">
      <div class="content-empty" v-if="list.total_count == 0">
        <div class="emptyimg-box"></div>
        <p>暂无相关内容</p>
      </div>
      <div v-for="(item, index) in list.items" :key="index" class="item">
        <router-link
          :to="{ name: 'CourseDetails', params: { id: item.id } }"
          class="img-box"
        >
          <el-image :src="item.cover">
            <div slot="error" class="image-slot">
              <img src="../../assets/images/default-kc.png" />
            </div>
          </el-image>
        </router-link>
        <div class="center">
          <h3>{{ item.name }}</h3>
          <div class="txt" v-if="item.start_time && item.end_time">
            {{ item.lecturer_name || '无讲师' }}
            | {{ item.start_time }} ~ {{ item.end_time }}
          </div>
          <div class="txt" v-else>
            {{ item.lecturer_name || '无讲师' }}
          </div>
          <div class="con">
            {{ item.description }}
          </div>
          <div class="operate">
            <router-link
              :to="{ name: 'CourseDetails', params: { id: item.id } }"
              class="uc-btn"
            >
              继续学习
              <i class="uc-font uc-next"></i>
            </router-link>
          </div>
        </div>
        <div class="chart-box" :id="forProcessChartId(index)"></div>
      </div>
    </section>

    <el-pagination
      class="uc-prvNxt"
      background
      layout="prev, pager, next"
      hide-on-single-page
      :current-page="query.pageIndex"
      :page-size="query.pageSize"
      :total="list.total_count"
      @current-change="handleCurrentChange"
    >
    </el-pagination>
  </div>
</template>

<script>
import { getAnnulusOption } from '@/utils/echartsOption.js';

export default {
  name: 'StudyCourse',
  data() {
    return {
      tabList: [
        { name: '学习中', status: 0 },
        { name: '已完成', status: 1 },
      ],
      query: {
        status: 0,
        pageIndex: 1,
        pageSize: 6,
        orderby: 0,
        keyword: undefined,
      },
      list: [],
      forProcessChartId: (index) => 'myProcessChart' + index,
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.getMyCourses();
    },
    async getMyCourses() {
      const response = await this.$api.course.getMyCourses(this.query);
      this.list = response.data.data;
      // 进度图表
      this.$nextTick(() => {
        const chartDom = document.getElementsByClassName('chart-box');
        for (let i = 0; i < chartDom.length; i++) {
          this.renderChart(
            'myProcessChart' + i,
            this.list.items[i].browse_percent,
            100
          );
        }
      });
    },
    // 翻页
    handleCurrentChange(val) {
      this.query.pageIndex = val;
      this.loadData();
    },
    /**
     * @param {String} id  获取HTML div元素的 ID,
     * @param {Number} dividend  数值1，（成功个数）
     * @param {Number} divisor   数值2，（总数）
     */
    renderChart(id, dividend, divisor) {
      this.$echarts.dispose(document.getElementById(id));
      const data = [dividend, divisor - dividend];
      const colors = ['#4b7efe', '#beddff'];
      const percentage = divisor === 0 ? 0 : (dividend / divisor) * 100;
      const text = this.formatValue(percentage, 1) + '%';
      const subText = '';
      const textFontSize = 20;
      const subTextFontSize = 0;
      const option = getAnnulusOption(
        data,
        colors,
        text,
        subText,
        textFontSize,
        subTextFontSize
      );
      const charts = this.$echarts.init(document.getElementById(id));
      charts.setOption(option);
    },
    /**
     * @param {number or string} value 数值
     * @param {Number} digits 保留小数位数
     * @param {bool} returnStr 返回值是字符串（如果保留位数那么返回是一个string）
     */
    formatValue(value, digits, returnStr = false) {
      if (digits < 0) {
        console.log('小数点后位数不能为负数');
        value = 0;
      }
      if (!value) {
        value = 0;
      }
      if (returnStr) {
        return parseFloat(value).toFixed(digits);
      }
      return parseFloat(parseFloat(value).toFixed(digits));
    },
  },
};
</script>
